<div class="card card-nc esign_box ">
  <div class="container">
    <div class="col-12">
      <div style="width: 80%; margin: 0 auto;">
        <app-progress-bar
          [whichStep]="5"
          [sectionsArray]="tabs"
        ></app-progress-bar>
      </div>
    </div>
  </div>
  <br />
  <div class="enrollHeading">
    Your Account is Now Setup!
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <b>Picking up your card on ship?</b><br />
            If you are picking up your card on ship, see disbursing officer and
            bring your CAC or ID card.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="enrollHelpTitle">
            <b>Picking up your card off ship?</b><br />
            If you are picking up your card off ship, see your authorized
            official in the finance office and bring your CAC or ID card.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <button
        id="enroll_button"
        type="button"
        class="btn btn-block pull-right"
        (click)="done()"
      >
        Done
      </button>
    </div>
  </div>
</div>
